import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';

ReactDOM.createRoot(document.getElementById('root')).render(
    <div>
        <App />
    </div>
);


// ReactDOM.render(<App />, document.getElementById("root"));